<template>
    <div>
        111
    </div>
</template>

<script>
export default {
    name: 'YunlinkPersonalCenterFooterGuide',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/FooterGuide/FooterGuide.vue